var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7752 13.6667C11.3707 13.6667 9.93072 13.315 8.45516 12.6117C6.97961 11.9084 5.60627 10.9209 4.33516 9.64921C3.07405 8.3781 2.09183 7.00726 1.3885 5.53671C0.685163 4.06615 0.333496 2.62893 0.333496 1.22504C0.333496 0.975041 0.41683 0.76393 0.583496 0.591707C0.750163 0.419485 0.958496 0.333374 1.2085 0.333374H3.26933C3.496 0.333374 3.69377 0.404763 3.86266 0.547541C4.03155 0.690318 4.14572 0.873374 4.20516 1.09671L4.6185 3.08337C4.65738 3.31671 4.65044 3.52032 4.59766 3.69421C4.54488 3.8681 4.45239 4.0106 4.32016 4.12171L2.49183 5.82671C2.83405 6.44726 3.21211 7.02393 3.626 7.55671C4.03989 8.08949 4.48155 8.59421 4.951 9.07087C5.43433 9.55421 5.95489 10.0042 6.51266 10.4209C7.07044 10.837 7.68266 11.2298 8.34933 11.5992L10.1318 9.78504C10.2674 9.63893 10.4199 9.54254 10.5893 9.49587C10.7582 9.44976 10.9454 9.4406 11.151 9.46837L12.9035 9.82671C13.1302 9.88226 13.3141 9.99643 13.4552 10.1692C13.5963 10.342 13.6668 10.5398 13.6668 10.7625V12.7917C13.6668 13.0417 13.5807 13.25 13.4085 13.4167C13.2363 13.5834 13.0252 13.6667 12.7752 13.6667Z",
    fill: "url(#paint0_linear_1019_4455)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1019_4455",
    x1: 7.00016,
    y1: 0.333374,
    x2: 7.00016,
    y2: 13.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4428A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerCall);
export default __webpack_public_path__ + "static/media/customer-call.8e9fbbf78dbe3cbccacb81596f5a25cc.svg";
export { ForwardRef as ReactComponent };